import { render, staticRenderFns } from "./UserSugSelect.vue?vue&type=template&id=56eac534&scoped=true&"
import script from "./UserSugSelect.vue?vue&type=script&lang=js&"
export * from "./UserSugSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserSugSelect.vue?vue&type=style&index=0&id=56eac534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eac534",
  null
  
)

export default component.exports